import styled from "styled-components";

export const BillingObservationContainer = styled.div`
  width: 100%;
  height: 280px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const BillingObservationContainerContent = styled.div`
  width: 100%;
  height: 120px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const BillingObservationContainerContentTitle = styled.div`
  width: 80%;
  height: 20px;
  position: relative;
  margin-left: auto;
  margin-right: auto;

  p {
    font-size: 22px;
    font-family: "Akrobat";
    color: rgb(61,61,61);
  }
`;
export const BillingObservationContainerContentFieldTitle = styled.div`
  width: 80%;
  // height: 60px;
  min-height: 60px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  border: 0.3px solid rgb(230, 230, 230);
  display: flex;
  justify-content: center;
  align-items: center;
  label {
    font-size: 20px;
    font-family: "Akrobat ExtraBold";
    color: #ff7e00;
    margin-left: 10px;
  }
  textarea {
    width: 780px;
    height: auto;
    font-size: 18px;
    border-top: 0.3px solid rgb(230, 230, 230);
    border-bottom: 0.3px solid rgb(230, 230, 230);
    border-left: none;
    border-right: none;
    font-family: "Akrobat SemiBold";
    letter-spacing: 0.03rem;
    outline: none;
    text-align: left;
    resize: none;
    margin-left: 10px;
  }
`;
